import React, { ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface ChipProps {
  size: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  text: string | ReactNode;
  icon?: ReactNode;
}

const sizeMapping: Record<ChipProps["size"], string> = {
  xs: "text-xs px-2 py-0.5",
  sm: "text-sm px-2.5 py-0.75",
  md: "text-md px-3 py-1",
  lg: "text-lg px-3.5 py-1.5",
  xl: "text-xl px-4 py-2",
};

export const Chip: React.FC<ChipProps> = ({
  size = "xs",
  text,
  icon,
  className,
}) => (
  <div
    className={cn(
      "rounded-xl bg-yellow-200 text-black shadow-yellow-100 shadow-chip font-light flex gap-1 items-center",
      sizeMapping[size],
      className,
    )}
  >
    {icon || null} {text ?? ""}
  </div>
);
